import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './custom.scss';
import "antd/dist/antd";
import { UserProvider } from './providers/UserProvider.jsx';
import { PusherProvider } from './providers/PusherProvider.jsx';
import { NotificationProvider } from './providers/NotificationProvider.jsx';
import { ThemeProvider } from './contexts/ThemeContext.jsx';
// import "antd/dist/reset.css";

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <UserProvider>
        <PusherProvider>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </PusherProvider>
      </UserProvider>
    </ThemeProvider>
  </StrictMode>,
)
